import React from 'react';
import { Button } from '@mui/material';

type DialogActionsProps = {
  onSave: () => void;
  onCancel: () => void;
};

const DialogActionsComponent: React.FC<DialogActionsProps> = ({
  onSave,
  onCancel
}) => {
  return (
    <div className="flex items-center justify-end gap-4 mt-4 w-full">
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{ minWidth: 160, maxWidth: 200, flexShrink: 1 }}
      >
        Cancel
      </Button>
      <Button
        onClick={onSave}
        variant="contained"
        sx={{ minWidth: 160, maxWidth: 200, flexShrink: 1 }}
      >
        Save
      </Button>
    </div>
  );
};

export default DialogActionsComponent;
